module.exports = window.I18n;